import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./meeting.module.scss";
import Images from "assets/Images";

const JitsiMeeting = ({
  roomName = "N7",
  displayName = "",
  onButtonClick,
  mouseEventTriggered,
  chatOpen
}) => {
  const jitsiContainerRef = useRef(null);
  const apiRef = useRef(null);
  const previousChatState = useRef(null);
  const navigate = useNavigate();

  const [participants, setParticipants] = useState([]);
  const [participantsViewState, setParticipantsViewState] = useState(false);
  const [mouseEvent, setMouseEvent] = useState(null);

  /* ------------------ INIT JITSI ------------------ */
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://meet.jit.si/external_api.js";
    script.async = true;

    script.onload = () => {
      if (!jitsiContainerRef.current) return;

      const domain = "meet.okotech.ai";

      const options = {
        roomName,
        parentNode: jitsiContainerRef.current,
        width: "100%",
        height: "100%",
        userInfo: {
          displayName
        },
        configOverwrite: {
          prejoinPageEnabled: true,
          startWithAudioMuted: false,
          startWithVideoMuted: false,
          enableClosePage: false
        },
        interfaceConfigOverwrite: {
          FILM_STRIP_ENABLED: false,
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          TOOLBAR_BUTTONS: [
            "microphone",
            "camera",
            "hangup",
            "participants-pane",
            "chat"
          ]
        }
      };

      const api = new window.JitsiMeetExternalAPI(domain, options);
      apiRef.current = api;

      /* ------------ EVENTS ------------ */
      api.addEventListener("videoConferenceJoined", () => {
        onButtonClick?.();
      });

      const updateParticipants = () => {
        const list = api.getParticipantsInfo();
        const unique = Array.from(
          new Map(list.map(p => [p.participantId, p])).values()
        );
        setParticipants(unique);
      };

      api.addEventListener("participantJoined", updateParticipants);
      api.addEventListener("participantLeft", updateParticipants);
      api.addEventListener("participantRoleChanged", updateParticipants);
      api.addEventListener("videoConferenceJoined", updateParticipants);

      api.addEventListener("participantsPaneToggled", event => {
        setParticipantsViewState(event.open);
      });

      api.addEventListener("videoConferenceLeft", () => {
        navigate("/meetingended");
      });
    };

    document.body.appendChild(script);

    return () => {
      apiRef.current?.dispose();
    };
  }, [roomName, displayName, navigate, onButtonClick]);

  /* ------------------ MOUSE TRACK ------------------ */
  useEffect(() => {
    mouseEventTriggered?.(mouseEvent);
  }, [mouseEvent, mouseEventTriggered]);

  useEffect(() => {
    const handler = e => setMouseEvent(e.clientX);
    window.addEventListener("mousemove", handler);
    return () => window.removeEventListener("mousemove", handler);
  }, []);

  /* ------------------ RENDER ------------------ */
  return (
    <div className={styles.meetingLayout}>
      
      {/* 🎥 JITSI VIDEO (FIXED POSITION) */}
      <div className={styles.videoWrapper}>
        <div ref={jitsiContainerRef} className={styles.jitsiContainer} />
      </div>

      {/* 👥 CUSTOM PARTICIPANTS PANEL */}
      {participantsViewState && (
        <div className={styles.partEmotionCont}>
          <ul>
            {participants.map(p => (
              <li key={p.participantId}>
                <img src={Images.HAPPY_ACTIVE} alt="emotion" width="20" />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default JitsiMeeting;
